import PropTypes from 'prop-types';

export const collectionProps = {
  description: PropTypes.string,
  displayType: PropTypes.string,
  id: PropTypes.string,
  showHeaderBlock: PropTypes.bool,
  thumbnailImage: PropTypes.string,
  title: PropTypes.string,
  url: PropTypes.string,
};

export const collection = PropTypes.shape(collectionProps);
